module.exports = __webpack_public_path__ + "static/media/browse-portfolios.17cee64e.png";